





























































































import { Component, Inject, Prop, Mixins } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Mixins
import AdminBrandId from "@/mixins/adminBrandId";
import AdminBrands from "@/mixins/adminBrands";

// Types
import {
  ISupportDepartmentsProvider,
  ISupportDepartmentsProviderMethods
} from "@/models/providers/supportDepartments";

@Component({
  components: {
    "brand-logo": () => import("@/components/app/global/brand/logo.vue")
  }
})
export default class SupportDepartmentRowItem extends Mixins(
  AdminBrands,
  AdminBrandId
) {
  // Inject - Support departments list provider data

  @Inject({ from: "supportDepartmentsProvider" })
  public $supportDepartmentsData!: () => ISupportDepartmentsProvider;

  public get supportDepartmentsData() {
    return this.$supportDepartmentsData();
  }

  @Inject({ from: "supportDepartmentsProviderMethods" })
  public $supportDepartmentsMethods!: ISupportDepartmentsProviderMethods;

  // Props

  @Prop({ default: null })
  public supportDepartment!: any;

  @Prop({ default: false })
  public isLoading!: boolean;

  // Data

  public isAssigned = false;

  public created() {
    if (!this.showSkeletons && !this.isOrgMode) {
      this.isAssigned = _.some(
        this.supportDepartment.brand_ticket_departments,
        ["brand_id", this.brandId]
      );
    }
  }

  // Computed

  public get showSkeletons() {
    return _.isNull(this.supportDepartment);
  }

  public get brandAssignment() {
    return (
      _.find(this.supportDepartment?.brand_ticket_departments || [], [
        "brand_id",
        this.brandId
      ]) || null
    );
  }

  public get supportDepartmentBrandNames() {
    return _.filter(
      _.map(
        this.supportDepartment?.brand_ticket_departments || [],
        brandDepartment => {
          return this.getBrandName(brandDepartment.brand_id);
        }
      ),
      value => !_.isEmpty(value)
    );
  }

  public get supportDepartmentName() {
    return this.supportDepartment?.name || "";
  }

  public get supportDepartmentCode() {
    return this.supportDepartment?.code || "";
  }

  public get isBrandDefault() {
    return this.brandAssignment?.default || false;
  }
}
